import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { ResumeViewer } from "./ResumeViewer";

export const Resume = () => {
    
    const prefersReduced = typeof window !== "undefined" &&
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const container = {
        hidden: { 
            opacity: 0, 
            y: prefersReduced ? 0 : 30 
        },
        show: {
            opacity: 1,
            y: 0,
            transition: { 
                type: "spring", 
                stiffness: 80, 
                damping: 14, 
                mass: 0.6,
                staggerChildren: 0.08, 
                delayChildren: 0.05, 
            },
        },
    };

    return (
        <section className="resume" id="resume">
            <Container>
                <Row>
                    <Col>
                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.25 }}
                        variants={container}
                    >
                        <div className="resume-bx">
                            <h2>Resume</h2>
                            <ResumeViewer />
                        </div>
                    </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};